import axios from "axios";

const API = axios.create({ baseURL: process.env.REACT_APP_BASE_URL })
// const API = axios.create({ baseURL: "http://192.168.29.181" }) // Incorrect URL

export const dashboardApi = (headers,dateRange) => API.get(`/admin/dashboard?dateRange=`+dateRange, headers)